import { FormControl, FormHelperText, Switch, FormControlLabel } from "@mui/material";

interface ToggleProps {
   field: {
    value: boolean;
    onChange: (value: boolean) => void;
    onBlur?: () => void;
    name?: string;
  };
  label?: string;
  isDisabled?: boolean;
  error?: boolean;
  helperText?: string;
  sx?:any;
}

const Toggle = ({
  field,
  label,
  isDisabled = false,
  error = false,
  helperText,
  sx
}: ToggleProps) => {
  return (
    <FormControl error={error} sx={sx}>
      <FormControlLabel
        sx={{margin:0}}
        control={
          <Switch
            checked={!!field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            onBlur={field.onBlur}
            disabled={isDisabled}
          />
        }
        label={label}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default Toggle;